/**
 * CalendarPageV2.tsx — GlowPro (g=true)
 *
 * Wrapper de pantalla completa para CalendarModuleV2.
 * Escapa el padding del Layout con márgenes negativos
 * y aplica el tema oscuro del módulo de calendario.
 */

import React from 'react';
import { CalendarModuleV2 } from '../components/calendar/CalendarModuleV2';
import '../components/calendar/calendar-v2.css';

export default function CalendarPageV2() {
  return (
    <div
      className="cal-v2-root"
      data-app="glow"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 10,
      }}
    >
      <CalendarModuleV2 g={true} />
    </div>
  );
}
